export default __webpack_public_path__ + "static/media/logo.f252c002.png";